var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoFavoritesLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 81,
    viewBox: "0 0 84 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5173 65L17.1769 43.8119C4.49193 31.0991 23.1389 6.69047 40.5173 26.4377C57.8957 6.69047 76.4581 31.1839 63.8577 43.8119L40.5173 65Z",
    fill: "#FB275D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0105 55.0687L48.8195 40.1886C48.4233 39.9214 47.9027 40.2697 47.9935 40.737L53.1065 66.9542C53.2073 67.4586 53.8792 67.5437 54.1106 67.0977L59.3621 56.9529L70.7533 56.0494C71.2575 56.0098 71.4329 55.3532 71.0105 55.0687Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.75586,
    y: 3.54785,
    width: 73.7906,
    height: 73.981,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.293,
    y: 0.5,
    width: 7.20873,
    height: 6.93571,
    fill: "white",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75.293,
    y: 73.3477,
    width: 7.20873,
    height: 6.93571,
    fill: "white",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7.20873,
    height: 6.93571,
    fill: "white",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 73.3477,
    width: 7.20873,
    height: 6.93571,
    fill: "white",
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFavoritesLogo);
export default __webpack_public_path__ + "static/media/no-favorites-logo.a6a7ca380277a08ae68364b1a32fcf2e.svg";
export { ForwardRef as ReactComponent };